// IMPORT SASS
import '../sass/style.scss';

// IMPORT JAVASCRIPT
import './_animation.js';
import { Slick } from 'slick-carousel';

import $ from "jquery"; 



$(window).on('load', function(){

    $('body').addClass('loaded');

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if(urlParams.get('lpc')) {
        $('html,body').stop().animate({
            'scrollTop': $('.blog_latest_posts').first().offset().top - $('#branding').outerHeight()
        }, 800)
    }

    handleIconColumnTextHeights()
    $(window).on('resize', handleIconColumnTextHeights())
    
});

$('a.menu-toggle').on('click', function(e){
    console.log('clicked');
    $('body').toggleClass('mobile-overlay-menu-active');
    window.dispatchEvent(new Event('resize'));
    e.preventDefault();
});

$('a[href^="#"]').on('click', function(e){
    
    const el = $(this).attr('href')
    if(el.length > 1) {
        $('html,body').stop().animate({
            'scrollTop': $(el).first().offset().top - $('#branding').outerHeight()
        }, 800)
        e.preventDefault()
    }
})

handleMenuScroll();
$(document).on('scroll', function() {
    handleMenuScroll();
})
function handleMenuScroll() {
    if ($(document).scrollTop() >= 100) {
        $('#branding').addClass('scrolled')
    } else {
        $('#branding').removeClass('scrolled')
    }
}

$('.component.reviews .items').slick()

// Featured Posts Banner
$('.blog_featured_posts_banner .posts').slick({
    infinite: true,
    dots: true,
    arrows: false,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplaySpeed: 3000,
})

$('.copy-url-to-clipboard').on('click', function(e){ 
    e.preventDefault()
    let shareCont = $(this)
    navigator.clipboard.writeText(window.location.href).then(
        function() {
            console
            shareCont.find(".message").addClass('on');
            setTimeout(()=>{ shareCont.find('.on').removeClass('on')},1500)
        }, 
        function() {
          /* clipboard write failed */
          window.alert('Opps! Your browser does not support the Clipboard API. We could not copy the page URL.')
        }
      )
})

function handleIconColumnTextHeights() {
    $('.component.icon_columns .text').removeAttr('style')
    $('.component.icon_columns').each(function(){
        let tallest = 0;
        $(this).find('.items').each(function(){
            let textH = $(this).find('.text').height()
            if(tallest < textH) tallest = textH
        })
        $(this).find('.text').height(tallest)
    })
}